import texts from '../../../../globals/constants';

export default (date) => {
	const day = date.getDate();
	const month = date.getMonth();
	const year = date.getFullYear();
	return `${day} ${texts.ruMonths[month]} ${year}`;
};
